import React, { useEffect, useRef, useState } from 'react';

import { useScrollState } from '../../../../hooks/useScrollState/useScrollState';
import { ITertiaryHero } from '../../../../interfaces/hero';

import './TertiaryHero.scss';

const TertiaryHero = ({ title, color, bottomContent }: ITertiaryHero) => {
  const isScrolled = useScrollState(0);
  const heroRef = useRef<HTMLDivElement>(null);
  const [heroHeight, setHeroHeight] = useState(0);

  useEffect(() => {
    const updateHeroHeight = () => {
      if (heroRef.current) setHeroHeight(heroRef.current.offsetHeight);
    };

    const observer = new ResizeObserver(() => updateHeroHeight());
    if (heroRef.current) observer.observe(heroRef.current);

    updateHeroHeight();

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div ref={heroRef} className={`main-hero tertiary-hero ${color} ${isScrolled ? 'collapsed' : ''}`}>
        <div className="bottom-content">
          {title && <div className="title">{title}</div>}
          {bottomContent}
        </div>
      </div>
      <div style={{ height: isScrolled ? 0 : heroHeight, transition: 'height 0.3s ease' }} />
    </>
  );
};

export default TertiaryHero;
